// src/components/SellCarDropdown.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/SellCarDropdown.css';
import ComingSoonPopup from './ComingSoonPopup';

const SellCarDropdown = ({ onClose }) => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  const activeCities = [
    { label: 'Sell Car Online',        slug: 'indore'    },
    { label: 'Sell cars in Indore',    slug: 'indore'    },
    { label: 'Sell cars in Dewas',     slug: 'dewas'     },
    { label: 'Sell cars in Ujjain',    slug: 'ujjain'    },
    { label: 'Sell cars in Mhow',      slug: 'mhow'      },
    { label: 'Sell cars in Pithampur', slug: 'pithampur' },
  ];

  const newCities = [
    'Delhi NCR', 'Bangalore', 'Hyderabad', 'Mumbai', 'Pune', 'Delhi',
    'Gurgaon', 'Noida', 'Ahmedabad', 'Chennai', 'Lucknow', 'Jaipur', 'Kolkata',
  ];

  const handleActiveClick = (slug) => {
    navigate(`/sell-car/${slug}/journey`);
    onClose();
  };

  return (
    <>
      <div className="sell-dropdown-panel">
        {/* Top accent */}
        <div className="sell-accent-bar" />

        <div className="sell-body">
          {/* ── LEFT: Active MP Cities ── */}
          <div className="sell-left">
            <div className="sell-section-head">
              <span className="sell-section-badge">M.P</span>
              <span className="sell-section-label">Available Now</span>
            </div>

            <div className="sell-mp-list">
              {activeCities.map((item, idx) => (
                <button
                  key={idx}
                  className="sell-mp-item"
                  onClick={() => handleActiveClick(item.slug)}
                  style={{ animationDelay: `${idx * 40}ms` }}
                >
                  <div className="sell-mp-item-left">
                    <span className="sell-mp-dot" />
                    <span className="sell-mp-label">{item.label}</span>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Vertical divider */}
          <div className="sell-vdivider" />

          {/* ── RIGHT: Other Cities grid ── */}
          <div className="sell-right">
            <div className="sell-section-head">
              <span className="sell-section-badge">All Cities</span>
              <span className="sell-section-label">More locations</span>
            </div>

            <div className="sell-cities-grid">
              {newCities.map((city, idx) => (
                <button
                  key={idx}
                  className="sell-city-item"
                  onClick={() => setShowPopup(true)}
                  style={{ animationDelay: `${idx * 30}ms` }}
                >
                  <span className="sell-city-label">Sell cars in {city}</span>
                  <span className="sell-city-arrow">›</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {showPopup && <ComingSoonPopup onClose={() => setShowPopup(false)} />}
    </>
  );
};

export default SellCarDropdown;